var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37205 10.0306C11.6803 10.0306 13.5514 7.78519 13.5514 5.01531C13.5514 2.24543 11.6803 0 9.37205 0C7.06382 0 5.19263 2.24543 5.19263 5.01531C5.19263 7.78519 7.06382 10.0306 9.37205 10.0306Z",
    fill: "black",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 11.5C13.7477 9.99535 15.3905 11.5352 13.5515 10.7829C13.05 10.6156 12.4648 10.6156 12.0469 10.8664C11.2111 11.368 10.3752 11.6187 9.37209 11.6187C8.36903 11.6187 7.53314 11.368 6.69726 10.8664C6.27932 10.6993 5.6942 10.6156 5.19267 10.8664C3.35372 11.6187 1.93272 12.8726 1.18042 14.3771C0.5953 15.4638 1.51477 16.7177 2.7686 16.7177H10.9756C10.5 15.5 10.5 14.3771 14.5 11.5Z",
    fill: "black",
    fillOpacity: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8838 10C17.5809 10 19.7676 12.1866 19.7676 14.8838C19.7675 17.5809 17.5809 19.7675 14.8838 19.7676C12.1866 19.7676 10 17.5809 10 14.8838C10 12.1866 12.1866 10 14.8838 10ZM17.5996 12.7568C17.5641 12.7223 17.5101 12.7223 17.4746 12.7568L14.0859 16.0557L12.2852 14.3027C12.2496 14.2682 12.1957 14.2682 12.1602 14.3027L11.4062 15.0361C11.3709 15.0706 11.371 15.1227 11.4062 15.1572L14.0234 17.7051C14.0589 17.7395 14.112 17.7393 14.1475 17.7051L18.3535 13.6113C18.3886 13.5769 18.3886 13.5256 18.3535 13.4912L17.5996 12.7568Z",
    fill: "#A7A7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCheck);
export default __webpack_public_path__ + "static/media/UserCheck.3a0263c6.svg";
export { ForwardRef as ReactComponent };